import type { AppEnv } from '@hc-frontend/core-context';
import { getClientApplicationConfig } from '@hc-frontend/core-context';

const healthcareComLinkRegex = /^(www\.)?((stg|qa)\.)?healthcare\.com/;

export function isHealthcareComLink(url: URL) {
  return healthcareComLinkRegex.test(url.hostname);
}

const hostnameMap: Record<AppEnv, string> = {
  local: 'qa.healthcare.com',
  dev: 'stg.healthcare.com',
  qa: 'qa.healthcare.com',
  stg: 'stg.healthcare.com',
  prd: 'www.healthcare.com',
};

export function checkHealthcareComLink(url: URL): string {
  const config = getClientApplicationConfig();
  // eslint-disable-next-line no-param-reassign
  url.hostname = hostnameMap[config.core.appEnvironment];
  return decodeURIComponent(url.href);
}
